"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_LABEL = exports.OPTION_LABEL = void 0;
exports.OPTION_LABEL = {
    CORRECT: 'CORRECT',
    INCORRECT: 'INCORRECT',
    CORRECT_NOT_SELECTED: 'CORRECT_NOT_SELECTED',
    NOT_SELECTED: 'NOT_SELECTED',
};
exports.STATUS_LABEL = (_a = {},
    _a[exports.OPTION_LABEL.CORRECT] = 'Correct',
    _a[exports.OPTION_LABEL.INCORRECT] = 'Incorrect',
    _a[exports.OPTION_LABEL.CORRECT_NOT_SELECTED] = 'Correct not selected',
    _a[exports.OPTION_LABEL.NOT_SELECTED] = '',
    _a);
